<mat-toolbar
  class="header"
  sticky
>
  <button
    type="button"
    aria-label="Toggle sidenav"
    mat-icon-button
    (click)="sidenavService.toggle()"
  >
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>

  @if (!isHandset()) {
    <span>Job & Tool Management System</span>
    <img
      class="logo"
      ngSrc="assets/images/jtms-icons/jtms-mark.svg"
      width="45"
      height="45"
      alt="JTMS Logo"
    />
  } @else {
    <span>JTMS</span>
  }

  <span class="span"></span>

  <jtms-header-search />

  <span class="span"></span>

  @defer {
    <jtms-active-pressure-test />
    <span class="span"></span>
  }
  <jtms-view-scope-select class="view-scope-select" />

  @if (user(); as user) {
    <img
      class="user-photoURL"
      [src]="user.picture"
      alt="Your profile"
      [routerLink]="['/user', user.user_id]"
    />
  }

  @if (castMode.castable()) {
    <button
      type="button"
      mat-icon-button
      aria-label="Cast this page to a display"
      matTooltip="Cast to a display"
      (click)="castMode.start()"
    >
      <mat-icon>cast</mat-icon>
    </button>
  }

  <button
    type="button"
    aria-label="About JTMS"
    mat-icon-button
    [routerLink]="['/about']"
  >
    <mat-icon aria-label="About JTMS">info</mat-icon>
  </button>
</mat-toolbar>
